import React, { useState } from 'react'
import { Dialog, Tooltip, IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import DialogoAnuncioBuquesDelete from './DialogoAnuncioBuquesDelete'

function DeleteAnuncioBuques (props) {
  const { handleDelete, handleCancelar } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  return (
    <>
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='sm'>
          <DialogoAnuncioBuquesDelete handleClose={handleClose} handleSubmit={handleDelete} handleCancelar={handleCancelar} />
        </Dialog>
        <Tooltip title={'Eliminar'}>
          <IconButton onClick={handleOpen}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    </>
  )
}

export default DeleteAnuncioBuques
